<template>
    <v-container
        :fluid="!loading"
        :grid-list-lg="!loading"
        :class="[loading ? 'screen-loading' : '', $vuetify.breakpoint.lgAndUp ? '' : 'pt-0']"
        fill-height
    >
        <template
            v-if="!loading"
        >
            <v-layout
                wrap
                justify-center
            >
                <v-flex
                    xs12
                    sm12
                    md8
                    class="pt-0"
                >
                    <mobile-summary
                        v-if="isMobile && benefits_requested"
                    ></mobile-summary>

                    <stepper/>

                    <mobile-bottom
                        v-if="isMobile && current_step == 2"
                    ></mobile-bottom>
                </v-flex>
                <v-flex
                    xs12
                    sm12
                    md4
                    class="pt-0"
                    v-show="!isMobile"
                >
                    <side-menu/>
                </v-flex>
            </v-layout>
        </template>
        <v-layout
            v-else
            justify-center
            align-center
            column
        >
            <v-progress-circular
                :size="50"
                color="secondary"
                indeterminate
            ></v-progress-circular>
        </v-layout>
    </v-container>
</template>
<script>
    import SideMenu from "./Summaries/Side";
    import MobileSummary from "./Summaries/Mobile";
    import MobileBottom from "./Summaries/MobileBottom";
    import Stepper from "./Stepper";

    import KeyPlanMixin from "./keyplan";

    export default {

        components: {
            SideMenu,
            MobileSummary,
            Stepper,
            MobileBottom
        },

        mixins: [
            KeyPlanMixin
        ],

        data() {
            return {
                loadedNewQuote: false,
            }
        },

        computed: {
            loading() {
                return !(this.loadedNewQuote && this.loadedResources);
            },
            loadedResources() {
                return this.$store.getters['calculators/getResourcesLoaded'];
            }
        },

        mounted() {
            this.newQuote();
            this.getGeneralResources();
        },

        methods: {
            getGeneralResources() {
                this.$store.dispatch('calculators/getAll');
                this.$store.dispatch('keyplan/getResources');
            },
            newQuote() {
                this.$store.dispatch('keyplan/newQuote')
                    .then((response) => {
                        this.loadedNewQuote = true;
                    });
            }
        }
    }
</script>
